export const KEVINS_PICKS_CATEGORY = 'Kevin’s Picks' as const

const normalize = (value: string): string => value.toLowerCase().replace(/[^a-z0-9]/g, '')

const games = [
  { name: 'Gates of Olympus Roulette', ids: ['GatesOfOlympusRoulette'] },
  { name: 'Amazing Baccarat', ids: ['AmazingBaccarat'] },
  { name: 'Mega Wheel', ids: ['13310', 'MegaWheel'] },
  { name: 'Mega Roulette', ids: ['10514', 'MegaRoulette'] },
  { name: 'Money Time', ids: ['60392', 'MoneyTime'] },
  { name: 'Sweet Bonanza CandyLand', ids: ['13810', 'SweetBonanzaCandyland'] },
]

interface CampaignGame {
  gameId?: string
  externalId?: string
  gameName?: string
  name?: string
  provider?: string
}

export const getKevinsPicksOrder = (slot: CampaignGame): number => {
  if (!normalize(slot.provider || '').startsWith('pragmatic')) return -1
  const rawId = slot.externalId || slot.gameId || ''
  const pureId =
    rawId
      .split('__')
      .find(part => part.startsWith('id:'))
      ?.slice(3) || rawId
  const id = normalize(pureId.slice(pureId.lastIndexOf(':') + 1))
  const name = normalize(slot.gameName || slot.name || '')
  return games.findIndex(game => normalize(game.name) === name || game.ids.some(alias => normalize(alias) === id))
}

export const selectKevinsPicks = <T extends CampaignGame>(slots: T[]): T[] => {
  const seen = new Set<number>()
  return slots
    .filter(slot => {
      const order = getKevinsPicksOrder(slot)
      if (order < 0 || seen.has(order)) return false
      seen.add(order)
      return true
    })
    .sort((first, second) => getKevinsPicksOrder(first) - getKevinsPicksOrder(second))
}

export const insertKevinsPicks = (items: string[], after?: string): string[] => {
  const list = items.filter(item => item !== KEVINS_PICKS_CATEGORY)
  const index = after ? list.indexOf(after) + 1 : 0
  return [...list.slice(0, index), KEVINS_PICKS_CATEGORY, ...list.slice(index)]
}
